import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { DataTableColumnType, DataTableItemType } from 'Types';

export default class DataTableCellFormattedMessage extends PureComponent {
    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType,
        item: DataTableItemType.isRequired,
        value: PropTypes.string
    };

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const { column, value } = this.props;
        return <div>{this.context.intl.formatMessage({ id: `${column.prefix}.${value}` })}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableBody/DataTableCells/DataTableCellFormattedMessage.jsx